export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8283.ef09eb15.jpg";